import {useHasContentForAllBrandKitsLoaded} from "@Hooks/brands/useHasContentForAllBrandKitsLoaded";
import {useAppSelector} from "@/hooks";

export const useIsInputPanelLoading = (): boolean => {
    const hasBrandKitsContentLoaded = useHasContentForAllBrandKitsLoaded();
    return useAppSelector(state => {
        return state.fontSelector.areFontsLoading || !hasBrandKitsContentLoaded;
    })
}